/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { ImportPriceItemsRestService, UomRestService } from '@gh/builder-shared-data';
import { DictionaryService } from '@gh/common-shared';
import { EMPTY$ } from '@gh/rx';
import { Observable } from 'rxjs';
import {
  ImportPriceApplyItem,
  ImportPriceBatchId,
  ImportPriceFileItem,
  ImportPriceItemsCount,
} from '../resources/estimating-import-price-tab.model';
import { GoogleDocument } from '@gh/common-internal-shared';

@Injectable()
export class EstimatingImportPriceTabBusinessService {

  constructor(private restService: ImportPriceItemsRestService,
              private uomRest: UomRestService,
              private userContext: BuilderUserContext,
              private dictionaryService: DictionaryService) {
  }

  /**
   * @returns {{gridLayout: Observable<GridLayout>}}
   */
  initView(): any {
    const { office } = this.userContext;
    return {
      uoms: office ? this.uomRest.findAllShared() : EMPTY$,
    };
  }

  getBatchId(file: File): Observable<ImportPriceBatchId> {
    return this.restService.getBatchId(file);
  }

  getGoogleBatchId(sheet: GoogleDocument): Observable<ImportPriceBatchId> {
    return this.restService.getGoogleBatchId(sheet.id);
  }

  // fixme: status -> enum type
  findFileItems(batchId: string, status: string): Observable<ImportPriceFileItem[]> {
    return this.restService.findNewItems(batchId, status);
  }

  apply(batchId: string, items: ImportPriceApplyItem[]): Observable<ImportPriceApplyItem[]> {
    return this.restService.apply(batchId, items);
  }

  itemsCount(batchId: string): Observable<ImportPriceItemsCount[]> {
    return this.restService.itemsCount(batchId);
  }
}
